"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24ThumbsUpLine = function Svg24ThumbsUpLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.766 10.061a6.284 6.284 0 0 0 1.436-1.335c.848-1.069 1.525-2.577 1.525-4.513a1 1 0 0 1 .302-.716c.181-.177.417-.304.572-.382.183-.093.394-.184.608-.27.428-.173.922-.345 1.337-.483a1.943 1.943 0 0 1 2.512 1.404c.268 1.15.69 3.19.759 5.01l.845.074a3 3 0 0 1 2.618 3.827l-1.146 3.936a5 5 0 0 1-2.896 3.226l-1.173.483c-1.06.436-2.319.74-3.617.472-1.23-.254-2.534-.71-3.562-1.128A2 2 0 0 1 7 21H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2a2 2 0 0 1 1.766 1.061zm5.19-5.36c.356-.144.781-.294 1.168-.424.316 1.369.768 3.688.695 5.371a1 1 0 0 0 .911 1.04l1.757.154a1 1 0 0 1 .873 1.276l-1.146 3.936a3 3 0 0 1-1.738 1.935l-1.173.483c-.874.36-1.7.519-2.45.364-1.353-.28-2.859-.854-3.853-1.294v-5.328c.922-.417 1.93-1.189 2.77-2.245 1.01-1.274 1.815-3.01 1.94-5.166.074-.032.156-.067.246-.103zM5 11h2v8H5v-8z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24ThumbsUpLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24ThumbsUpLine;
exports.default = _default;